/* Options by category - Used in Option Picker */

// Head has only 1 option (not listed here)
// Option '0' means none (i.e. 0 hair is bald)
export const HairOptions = [0, 1, 2, 3, 4, 5, 8, 9, 10, 11, 12, 13, 14, 15, 18, 19, 24, 26, 28, 29, 30, 32, 33, 36, 37, 38, 39, 40];
export const EyesOptions = [1, 2, 3, 4, 5, 6, 9, 11];
export const NoseOptions = [1, 2, 3, 4, 5, 6];
export const MouthOptions = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 12];
export const FacialHairOptions = [0, 1, 2, 3, 5];
export const EarsOptions = [1, 2, 3];
export const AccessoriesEyewearOptions = [0, 1, 2, 4, 8, 16, 17, 19, 20, 42, 43, 44, 45, 46];
export const AccessoriesHeadgearOptions = [0, 3, 5, 9, 11, 13, 14, 24, 25, 26, 28, 29, 33, 35, 47, 48, 49, 50, 51, 52, 53, 54, 55];
export const AccessoriesFanfettiOptions = [0, 37, 38, 39];
export const LogoOptions = [0, 1, 2];
export const BackgroundOptions = [1, 2, 3, 4, 5, 6];

/* Options with pattern exception */

// Hair
export const HairFrontNoBackList = [1, 8, 9, 10, 11, 13, 14, 19, 24, 26, 28, 29, 30, 39];
export const SingleColorHairFrontList = [5, 28, 29, 30, 38];
export const NoColorHairFrontList = [0, 10];
export const MultiColorHairBackList = [4, 18];

// Mouth
export const MouthWithColorList = [3];

// Facial Hair
export const FacialHairNoColorList = [0, 3, 5];
export const FacialHairMultiColorList = [2];
export const FacialHairBehindMouthList = [1, 2, 3, 5];

// Accessories color exceptions
export const MultiColorAccessoriesList = [1, 5];
export const Alt1ColorAccessoriesList = [1];
export const Alt3ColorAccessoriesList = [13];
export const Alt4ColorAccessoriesList = [14];
export const Alt7ColorAccessoriesList = [33];
export const AccessoriesWithHairColorList = [40, 41];
export const NoColorAccessoriesList = [0, 2, 4, 8, 16, 20, 24, 25, 35, 37, 38, 39, 42, 43, 44, 48, 51];

// Accessories behavior exceptions
export const AccessoriesBehindEarList = [2, 4, 8, 13, 19, 42, 43, 45];
export const AccessoriesBehindAllHairList = [14];
export const AccessoriesBehindHeadList = [40, 41];
export const AccessoriesOverrideEyesList = [1, 2, 4, 8, 17, 19, 42, 43, 45, 46];
export const AccessoriesOverrideHairList = [26, 29];
export const AccessoriesOverrideHairFrontList = [28, 33, 35, 47, 49, 51, 52, 55];
export const AccessoriesOverrideEarsList = [26];
